module.exports = __webpack_public_path__ + "img/(5).ed475b5d.jpg";